import React, { useState } from 'react';
import axios from 'axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  IconButton,
  Typography
} from '@mui/material';
import { Close } from '@mui/icons-material';
import api from '../config/backend';
import './css/Employee.css';

const employmentTypes = ['Permanent', 'Intern', 'Part Time'];

function AddEmployeeModal({ open, onClose, onSuccess, token }) {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    gender: '',
    company_email: '',
    personal_email: '',
    mobile_no: '',
    DOB: '',
    Permanent_Address: '',
    Present_Address: '',
    Employee_code: '',
    Designation: '',
    // Employment_type: '',
    date_of_Joining: '',
    // Role: '',
    // password: '',
    // profile: ''
  });

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when field is edited
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.firstName || !formData.firstName.trim()) {
      newErrors.firstName = 'First name is required';
    }

    if (!formData.Designation || !formData.Designation.trim()) {
      newErrors.Designation = 'Designation is required';
    }

    if (
      (!formData.company_email || !formData.company_email.trim()) &&
      (!formData.personal_email || !formData.personal_email.trim())
    ) {
      newErrors.company_email = 'At least one email is required';
      newErrors.personal_email = 'At least one email is required';
    }

    if (
      formData.company_email &&
      formData.company_email.trim() &&
      !/\S+@\S+\.\S+/.test(formData.company_email.trim())
    ) {
      newErrors.company_email = 'Invalid email format';
    }

    if (
      formData.personal_email &&
      formData.personal_email.trim() &&
      !/\S+@\S+\.\S+/.test(formData.personal_email.trim())
    ) {
      newErrors.personal_email = 'Invalid email format';
    }

    return newErrors;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setSubmitting(true);

    try {
      const response = await axios.post(`${api}/Employee/create`, {
        admintoken: token,
        ...formData
      });

      if (response.data.success) {
        onSuccess();
      } else {
        setErrors({ submit: response.data.message || 'Failed to create employee' });
      }
    } catch (error) {
      setErrors({ submit: 'Error creating employee' });
      console.error('Error creating employee:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      className="tracking-modal"
    >
      <DialogTitle className="modal-title">
        Add New Employee
        <IconButton onClick={onClose} className="close-button">
          <Close />
        </IconButton>
      </DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={3}>
            {/* Personal Information */}
            <Grid item xs={12}>
              <h3 className="section-title">Personal Information</h3>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                name="firstName"
                label="First Name *"
                value={formData.firstName}
                onChange={handleChange}
                fullWidth
                error={!!errors.firstName}
                helperText={errors.firstName}
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                name="lastName"
                label="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                fullWidth
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Gender</InputLabel>
                <Select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  label="Gender"

                >
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                name="DOB"
                label="Date of Birth"
                type="date"
                value={formData.DOB}
                onChange={handleChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
                size="small"
                inputProps={{ max: new Date().toISOString().split("T")[0] }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                name="mobile_no"
                label="Mobile Number"
                value={formData.mobile_no}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || (/^\d+$/.test(value)) && value.length <= 10) {
                    setFormData({ ...formData, mobile_no: value });
                  }

                }}
                fullWidth
                size="small"
              />
            </Grid>

            {/* Contact Information */}
            <Grid item xs={12}>
              <h3 className="section-title">Contact Information</h3>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                name="company_email"
                label="Company Email *"
                value={formData.company_email}
                onChange={handleChange}
                fullWidth
                error={!!errors.company_email}
                helperText={errors.company_email}
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                name="personal_email"
                label="Personal Email *"
                value={formData.personal_email}
                onChange={handleChange}
                fullWidth
                error={!!errors.personal_email}
                helperText={errors.personal_email}
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                name="Permanent_Address"
                label="Permanent Address"
                value={formData.Permanent_Address}
                onChange={handleChange}
                fullWidth
                multiline
                rows={2}
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                name="Present_Address"
                label="Present Address"
                value={formData.Present_Address}
                onChange={handleChange}
                fullWidth
                multiline
                rows={2}
                size="small"
              />
            </Grid>

            {/* Employment Information */}
            <Grid item xs={12}>
              <h3 className="section-title">Employment Information</h3>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                name="Employee_code"
                label="Employee Code"
                value={formData.Employee_code}
                onChange={handleChange}
                fullWidth
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                name="Designation"
                label="Designation *"
                value={formData.Designation}
                onChange={handleChange}
                fullWidth
                error={!!errors.Designation}
                helperText={errors.Designation}
                size="small"
              />
            </Grid>

            {/* <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth>
                <InputLabel>Employment Type</InputLabel>
                <Select
                  name="Employment_type"
                  value={formData.Employment_type}
                  onChange={handleChange}
                  label="Employment Type"
                >
                  {employmentTypes.map(type => (
                    <MenuItem key={type} value={type}>{type}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid> */}

            <Grid item xs={12} sm={4}>
              <TextField
                name="date_of_Joining"
                label="Date of Joining"
                type="date"
                value={formData.date_of_Joining}
                onChange={handleChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
                size="small"
              />
            </Grid>

            {/* <Grid item xs={12} sm={6}>
              <TextField
                name="Role"
                label="Role"
                value={formData.Role}
                onChange={handleChange}
                fullWidth
              />
            </Grid> */}

            {/* Account Information */}
            {/* <Grid item xs={12}>
              <h3 className="section-title">Account Information</h3>
            </Grid> */}

            {/* <Grid item xs={12} sm={6}>
              <TextField
                name="password"
                label="Password *"
                type="password"
                value={formData.password}
                onChange={handleChange}
                fullWidth
                error={!!errors.password}
                helperText={errors.password}
              />
            </Grid> */}

            {/* <Grid item xs={12} sm={6}>
              <TextField
                name="profile"
                label="Profile URL"
                value={formData.profile}
                onChange={handleChange}
                fullWidth
              />
            </Grid> */}
          </Grid>

          {errors.submit && (
            <>

              <Grid item xs={12} sx={{ marginTop: "20px" }}>
                <h3 className="section-title" style={{ "color": "red" }}>Errors</h3>
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormHelperText error className="submit-error">
                  {errors.submit}
                </FormHelperText>
              </Grid>
            </>
          )}
        </DialogContent>

        <DialogActions className="modal-actions">
          <Button onClick={onClose} color="inherit">
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={submitting}
          >
            {submitting ? 'Saving...' : 'Save Employee'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default AddEmployeeModal;
